import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter, MatDatepicker, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'app/dashboard/dashboard.component';
import { ReportesService } from 'app/services/reportes/reportes.service';
import moment, { Moment } from 'moment';
import { exportJsonToExcel, servifinLabels } from 'app/shared/servifin-excel.export';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rep-mensual',
  templateUrl: './rep-mensual.component.html',
  styleUrls: ['./rep-mensual.component.scss'],
  providers:[DatePipe,
    {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class RepMensualComponent implements OnInit {

  labels = servifinLabels;
  date = new FormControl(moment());
  displayedColumns = ['idComprobante', 'Razon_Social', 'TipoComprobante', 'Serie', 'Numero','Fecha_Emision','Fecha_Vencimiento','Estado', 'Moneda','Num_Doc_Identificacion','fecha_tc','tc', 'Base_Importe', 'Base_Importe_Soles', 'Valor_Venta', 'IGV_Importe', 'Precio_Venta'];
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  dataSource: any;
  dataEnviar:any=[]
  dataLista:any=[]
  loading:boolean;
  forma: FormGroup;
  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private reporteService:ReportesService, private datePipe:DatePipe) {
    this.forma = new FormGroup({
      Serie: new FormControl(""),
      Moneda: new FormControl(0)
    })
   }

  ngOnInit() {    
    this.obtenerLista();
  }

  tipoMoneda(event){
    if(event==''){
      this.forma.controls['Moneda'].setValue(0);
    }else{
      this.forma.controls['Moneda'].setValue(event);
    }      
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);    
    datepicker.close();
  }

  alerta(){
    alert('ES GG');
  }

  ExportTOExcel() {
    exportJsonToExcel(this.dataLista, 'Sheet1', 'Reporte_Facturacion_Mensual_');
  }

  obtenerLista(){
    this.dataEnviar.Moneda=this.forma.controls['Moneda'].value
    this.dataEnviar.Periodo=this.datePipe.transform(this.date.value._d,'yyyyMM')
    this.dataEnviar.Serie=this.forma.controls['Serie'].value;
    this.loading=true;
    this.reporteService.ObtenerFacturasMensuales(this.dataEnviar).subscribe(
      res => {
        this.dataLista = res;      
        this.dataSource = new MatTableDataSource(this.dataLista);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },err =>{
          Swal.fire({
            title: "¡Algo salió mal!",
            text:  err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });        
          this.loading = false;
      }
    )
  }
  
}
